import axios from "axios";

import DropDown from "../../components/LaptopScreener/DropDown";
import PhoneScreener from "../../components/PhoneScreener/PhoneScreener";
import LaptopScreener from "../../components/LaptopScreener/LaptopScreener";
import MetaSection from "@/elements/MetaSection/MetaSection";
import { useContext, useEffect } from "react";
import { Mixpanel } from "@/elements/Mixpanel";
import PageNotFound from "../404";
import Actions from "@/elements/Actions";
import ScreenerFAQSection from "@/components/Screeners/ScreenerFAQSection";
import { UserDetailProvider } from "@/contexts/UserDetailContext";
import { useRouter } from "next/router";
import { useWindowSize } from "@uidotdev/usehooks";
import { StompSessionProvider } from "react-stomp-hooks";
const getScreenersList = async () => {
    let res = await axios.get(`${process.env.apiBaseURL}/resources/screeners/v3`).catch((err) => ({ data: {} }));
    return res;
};
const getScreenerDetails = async (screenerCode, auth_token = null) => {
    let res = await axios
        .get(`${process.env.apiBaseURL}/resources/screeners/${screenerCode?.toUpperCase()?.replaceAll("-", "_")}`, {
            headers: auth_token
                ? {
                      Authorization: `Bearer ${auth_token}`
                  }
                : {}
        })
        .catch((err) => ({ data: {} }));
    return res;
};

export default function ScreenerPage({
    name,
    screenersCategories,
    screenersList,
    screenerDetails,
    codeList,
    screenerData,
    seoData
}) {
    const { width } = useWindowSize();
    const userDetail = useContext(UserDetailProvider);
    const router = useRouter();
    useEffect(() => {
        userDetail.setBtn({
            show: true,
            beforeLogin: "Get started",
            afterLogin: "Download the app now",
            isProPage: true,
            page: "screeners_home"
        });
        Mixpanel.pageView({
            page: "screeners",
            screener_code: name
        });
    }, [name]);

    if (screenerDetails?.title) {
        return (
            <StompSessionProvider url={process.env.WS_BASE_URL}>
                <MetaSection
                    title={seoData?.title ?? `${name?.replaceAll("_", " ")} | Univest`}
                    desc={seoData?.desc ?? screenerDetails?.description}
                    keyWords={
                        seoData?.keywords ??
                        "stock screener, NSE stocks, stock filter, Indian stock market, stock analysis tool, stock research tool, breakout stocks, multibagger stocks"
                    }
                    schema={{
                        "@context": "https://schema.org",
                        "@graph": [
                            {
                                "@type": "WebSite",
                                "@id": "https://univest.in/#website",
                                url: "https://univest.in",
                                name: "Univest",
                                potentialAction: {
                                    "@type": "SearchAction",
                                    target: "https://univest.in/search?q={search_term_string}",
                                    "query-input": "required name=search_term_string"
                                }
                            },
                            {
                                "@type": "BreadcrumbList",
                                "@id": `https://univest.in${router?.asPath}`,
                                itemListElement: [
                                    {
                                        "@type": "ListItem",
                                        position: 1,
                                        name: "Home",
                                        item: "https://univest.in"
                                    }
                                ]
                            },
                            {
                                "@type": "Organization",
                                "@id": "https://univest.in/#organization",
                                url: "https://univest.in/",
                                name: "Univest",
                                logo: "https://storage.googleapis.com/app-assets-univest/website-assets/UnivestLogo.jpg",
                                address: {
                                    "@type": "PostalAddress",
                                    addressLocality: "Gurugram, Haryana",
                                    postalCode: "122002",
                                    streetAddress: "10, Poorvi Marg, DLF Phase 2, Sector 25, Gurugram, Haryana 122002"
                                },
                                email: "support@univest.in",
                                telephone: "+91-8800049790",
                                sameAs: [
                                    "https://www.facebook.com/Univest.in",
                                    "https://www.instagram.com/univest.in/",
                                    "https://twitter.com/UnivestIN",
                                    "http://linkedin.com/company/univest-in",
                                    "https://www.youtube.com/channel/UCRlFx-WxA4yY7Y33SRZaQ4w",
                                    "https://www.crunchbase.com/organization/univest-557f"
                                ],
                                contactPoint: [
                                    {
                                        "@type": "ContactPoint",
                                        telephone: "+91-8800049790",
                                        contactType: "Customer Service"
                                    }
                                ],
                                foundingDate: "2022",
                                founders: [
                                    {
                                        "@type": "Person",
                                        name: "Pranit Arora",
                                        id: "https://in.linkedin.com/in/pranit-arora-1b505422"
                                    },
                                    {
                                        "@type": "Person",
                                        name: "Avneet Dhamija",
                                        id: "https://in.linkedin.com/in/avneet-dhamija"
                                    },
                                    {
                                        "@type": "Person",
                                        name: "Vikash Agarwal",
                                        id: "https://in.linkedin.com/in/vikashagrawal1985"
                                    }
                                ],
                                funder: {
                                    "@type": "Corporation",
                                    legalName: "Trinity media Group",
                                    url: "https://www.vccircle.com/company/trinity-media-group"
                                }
                            },
                            screenerData?.META?.schema,
                            {
                                "@type": "Product",
                                "@id": "https://univest.in/#product",
                                name: "Stock Advisory service In India",
                                url: "https://univest.in/",
                                image: "",
                                review: [
                                    {
                                        "@type": "Review",
                                        reviewBody:
                                            "I like Today's Gainers and Today's Losers in Discover in the Invest section.It helps me plan which Stocks should I invest and which I should not",
                                        author: { "@type": "Person", name: "Baradi Shivakumar" },
                                        reviewRating: { "@type": "Rating", ratingValue: "4.9" },
                                        datePublished: "2023"
                                    },
                                    {
                                        "@type": "Review",
                                        reviewBody:
                                            "I like the Portfolio News in the Invest section on the univest App. It shows News related to the Stocks that are in my Portfolio which helps me in keeping a track of my Stocks status",
                                        author: { "@type": "Person", name: "Naman Nema" },
                                        reviewRating: { "@type": "Rating", ratingValue: "4.9" },
                                        datePublished: "2023"
                                    },
                                    {
                                        "@type": "Review",
                                        reviewBody:
                                            "I like the option chain section and the way Greeks are displayed as it is very simple to track and make decision to execute orders. It is also easy to buy and sell positions, UI is very nice.",
                                        author: { "@type": "Person", name: "Shiva singh" },
                                        reviewRating: { "@type": "Rating", ratingValue: "4.9" },
                                        datePublished: "2022"
                                    },
                                    {
                                        "@type": "Review",
                                        reviewBody: "Where trust matters univest never breaks.",
                                        author: { "@type": "Person", name: "Jatin" },
                                        reviewRating: { "@type": "Rating", ratingValue: "4.9" },
                                        datePublished: "2023"
                                    },
                                    {
                                        "@type": "Review",
                                        reviewBody:
                                            "The ROS feature is very good and can help the budding option traders to learn with proper discipline and risk management.",
                                        author: { "@type": "Person", name: "Pandi Donald" },
                                        reviewRating: { "@type": "Rating", ratingValue: "4.9" },
                                        datePublished: "2023"
                                    },
                                    {
                                        "@type": "Review",
                                        reviewBody:
                                            "I have been using univest for over 5 years now and it has provided me with an awesome experience and excellent customer support. Thanks to univest, I have also gained a lot of knowledge about stock market.",
                                        author: { "@type": "Person", name: "Prabhakar Dutta" },
                                        reviewRating: { "@type": "Rating", ratingValue: "4.9" },
                                        datePublished: "2023"
                                    },
                                    {
                                        "@type": "Review",
                                        reviewBody:
                                            "I like the Portfolio News in the Invest section on the univest App. It shows News related to the Stocks that are in my Portfolio which helps me in keeping a track of my Stocks status",
                                        author: { "@type": "Person", name: "Pandi Donald" },
                                        reviewRating: { "@type": "Rating", ratingValue: "4.9" },
                                        datePublished: "2023"
                                    }
                                ],
                                brand: "univest",
                                description:
                                    "Start Trading in Share Market, SIP, IPOs, Mutual Fund, Indices and Commodity at univest.in with hassle free process.",
                                aggregateRating: {
                                    "@type": "AggregateRating",
                                    ratingValue: "4.4",
                                    ratingCount: "230120",
                                    reviewCount: "197000"
                                }
                            }
                        ]
                    }}
                />

                <section className="lg:pt-24 font-Inter">
                    <div className="max-w-screen-xl mx-auto">
                        {width < 976 ? (
                            <PhoneScreener
                                title={screenerDetails.title}
                                name={name}
                                screenersList={screenersList}
                                data={screenerDetails}
                                codeList={codeList}
                            />
                        ) : (
                            <div className="hidden md:grid grid-cols-12 min-h-screen">
                                <div className="col-span-12 lg:col-span-3">
                                    {/* <DropDown screenersCategories={screenersCategories} screenersList={screenersList} selected={screenerDetails.categoryId} name={name} /> */}
                                    <DropDown
                                        screenersCategories={screenersCategories}
                                        screenersList={screenersList}
                                        selected={screenerDetails.categoryId}
                                        name={name}
                                        title={screenerDetails.title}
                                    />
                                </div>
                                <div className="col-span-12 lg:col-span-9">
                                    <LaptopScreener data={screenerDetails} name={name} />
                                    {seoData.content && (
                                        <div
                                            id="screener-seo"
                                            className="font-Inter mx-4 my-8 hidden md:block"
                                            dangerouslySetInnerHTML={{ __html: seoData.content }}
                                        />
                                    )}
                                    {/* {screenerData?.BOTTOM?.map((ele, j) => (
                                        <div key={j} className="font-Inter mx-4 my-8 hidden md:block">
                                            {ele.title && (
                                                <h2 className="text-xl leading-9 font-extrabold">{ele.title}</h2>
                                            )}
                                            {ele.disc && (
                                                <p
                                                    className="text-base leading-7 font-medium text-[#414141]"
                                                    dangerouslySetInnerHTML={{ __html: ele.disc }}
                                                />
                                            )}
                                            {ele.list && (
                                                <ul className="font-Inter list-decimal pl-5 list-outside text-justify">
                                                    {ele.list?.map((ele, i) => (
                                                        <li
                                                            key={i}
                                                            className="text-base leading-7 font-normal text-[#414141]"
                                                            dangerouslySetInnerHTML={{ __html: ele }}
                                                        />
                                                    ))}
                                                </ul>
                                            )}
                                        </div>
                                    ))} */}
                                </div>
                            </div>
                        )}
                        {/* {screenerData?.BOTTOM?.map((ele, j) => (
                            <div key={j} className="font-Inter mx-4 my-8 md:hidden block">
                                {ele.title && <h2 className="text-lg leading-8 font-extrabold">{ele.title}</h2>}
                                {ele.disc && (
                                    <p
                                        className="text-sm leading-6 font-medium text-[#414141]"
                                        dangerouslySetInnerHTML={{ __html: ele.disc }}
                                    />
                                )}
                                {ele.list && (
                                    <ul className="font-Inter list-decimal pl-5 list-outside text-justify">
                                        {ele.list?.map((ele, i) => (
                                            <li
                                                key={i}
                                                className="text-sm leading-6 font-normal text-[#414141]"
                                                dangerouslySetInnerHTML={{ __html: ele }}
                                            />
                                        ))}
                                    </ul>
                                )}
                            </div>
                        ))} */}
                        {seoData.content && (
                            <div
                                id="screener-seo"
                                className="font-Inter mx-4 my-8 md:hidden block"
                                dangerouslySetInnerHTML={{ __html: seoData.content }}
                            />
                        )}
                        <ScreenerFAQSection data={JSON.parse(seoData.faqs ?? "[]")} />
                    </div>
                </section>
            </StompSessionProvider>
        );
    } else {
        return <PageNotFound />;
    }
}

export async function getServerSideProps(context) {
    const { query, res, req } = context;
    const { name } = query;
    var changeName = null;

    // let res = await axios.get(`${process.env.apiBaseURL}/resources/screeners/v2`)
    // let ress = await axios.get(`${process.env.apiBaseURL}/resources/screeners/${name}`)

    const temp = {
        FUNDAMENTAL_STRONG_STOCKS: "fundamentally-strong-stocks",
        "fundamental-strong-stocks": "fundamentally-strong-stocks",
        "multi-bagger-stocks": "multibagger-stocks",
        HIGH_DIVIDEND_STOCKS: "highest-dividend-paying-stocks",
        "high-dividend-stocks": "highest-dividend-paying-stocks",
        "52WK_HIGH": "52-week-high",
        "52wk-high": "52-week-high",
        "52WK_LOW": "52-week-low",
        "52wk-low": "52-week-low"
    };
    if (Object.keys(temp).filter((f) => f === name).length > 0) {
        res.writeHead(301, {
            location: `/screeners/${temp[name] ?? ""}`
        });
        res.end();
    } else if (Object.values(temp).filter((f) => f === name).length > 0) {
        Object.entries(temp).map(([k, v]) => {
            if (v === name) {
                changeName = k;
            }
        });
    }
    // console.log(changeName);
    const [ress1, ress, ress2, ress3, footerContentRes] = await Promise.all([
        getScreenersList(),
        getScreenerDetails(changeName ?? name, req.cookies?.auth_token),
        axios.get(
            `https://univest.in/api/load-json?url=https://storage.googleapis.com/app-assets-univest/screeners/${(
                changeName ?? name
            )
                ?.toUpperCase()
                ?.replaceAll("-", "_")}.json`
        ),
        axios.get(`${process.env.apiBaseURL}/resources/web/seo-contents/${name}`).catch(() => ({})),
        axios.get(`${process.env.apiBaseURL}/resources/web/footer-sections`).catch(() => ({ data: null }))
    ]);

    const data = ress1.data?.data?.list;
    var screenerDetails = { ...ress.data?.screenerDetail, list: ress.data.list };
    if (
        data?.screenersList
            ?.filter((f) => !f.isFutureStock)
            ?.map((ele) => ele?.code)
            ?.includes(name)
    ) {
        res.writeHead(301, {
            location: Actions.toScreener(name)
        });
        res.end();
    }
    return {
        props: {
            footerContentData: footerContentRes?.data ?? null,
            screenersCategories: data?.screenersCategories?.filter((f) => !f.isFutureStockScreenerCategory),
            screenersList: data?.screenersList?.filter((f) => !f.isFutureStock),
            screenerDetails,
            name: (changeName ?? name)?.toUpperCase()?.replaceAll("-", "_"),
            codeList: data?.screenersList?.filter((f) => !f.isFutureStock)?.map((ele) => ele?.code),
            screenerData: ress2.data?.list ?? {},
            seoData: ress3.data ?? {}
        }
    };
}
